import { useLocation } from "react-router-dom";
import { PageHero } from "@/components/site/PageHero";

const CONTENT = {
  privacy: {
    eyebrow: "Legal",
    title: "Privacy Policy",
    intro: "How Beyond Potentials collects, uses and protects your personal data.",
    sections: [
      { h: "Who we are", p: "Beyond Potentials is a boutique executive search and talent development firm operating in Monaco, Geneva and Paris. We act as a data controller for the personal data described in this policy." },
      { h: "Data we collect", p: "We collect the information you provide through our forms (name, email, role, institution, market, message) and, for candidates, the CV you choose to share. We also collect basic analytics about how our site is used." },
      { h: "How we use your data", p: "We use your data solely to respond to your enquiry, to discuss relevant mandates or opportunities, and — where you have consented — to send occasional market intelligence. We never sell your data." },
      { h: "Confidentiality", p: "Discretion is the foundation of our business. We never share a candidate's details with an institution without explicit, role-by-role consent." },
      { h: "Your rights", p: "You may request access to, correction of, or deletion of your personal data at any time by contacting contact@beyondpotentials.com." },
    ],
  },
  terms: {
    eyebrow: "Legal",
    title: "Terms of Use",
    intro: "The terms governing your use of the Beyond Potentials website.",
    sections: [
      { h: "Use of this site", p: "This website is provided for information purposes. The content, including market intelligence and compensation tools, is indicative and does not constitute professional advice or a binding offer." },
      { h: "Intellectual property", p: "All content, branding and proprietary intelligence on this site are the property of Beyond Potentials and may not be reproduced without permission." },
      { h: "Compensation tools", p: "Figures produced by our Compensation Calculator are indicative ranges based on proprietary benchmarking and should not be relied upon as guaranteed outcomes." },
      { h: "Liability", p: "We take care to ensure information is accurate but accept no liability for decisions taken on the basis of the content provided here." },
    ],
  },
  "data-retention": {
    eyebrow: "Legal",
    title: "Data Retention",
    intro: "How long we keep your information, and why.",
    sections: [
      { h: "Retention principles", p: "We retain personal data only for as long as necessary to fulfil the purpose for which it was collected, or as required by applicable law." },
      { h: "Enquiries", p: "General enquiry data is retained for up to 24 months unless you ask us to delete it sooner." },
      { h: "Candidate data", p: "With your consent, we retain candidate profiles and CVs for up to 36 months so we can match you to future opportunities. You may withdraw consent at any time." },
      { h: "Deletion requests", p: "To request deletion of your data, email contact@beyondpotentials.com and we will action your request promptly." },
    ],
  },
};

export default function Legal() {
  const { pathname } = useLocation();
  const kind = pathname.replace("/", "");
  const data = CONTENT[kind] || CONTENT.privacy;
  return (
    <div data-testid="legal-page">
      <PageHero breadcrumb={[{ label: data.title }]} eyebrow={data.eyebrow} title={data.title} intro={data.intro} compact />
      <section className="pb-24">
        <div className="container-bp max-w-3xl">
          <div className="space-y-10">
            {data.sections.map((s, i) => (
              <div key={i}>
                <h2 className="font-display text-xl font-semibold text-[color:var(--bp-cream)]">{s.h}</h2>
                <p className="mt-3 text-[15px] leading-[1.8] text-[color:var(--bp-text-muted)]">{s.p}</p>
              </div>
            ))}
            <p className="border-t border-[color:var(--bp-border)] pt-6 text-[13px] text-[color:var(--bp-text-muted)]/70">Last updated June 2026. Questions? Email contact@beyondpotentials.com.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
